import '@antonpodolsky/design-system/foundations/base.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Homepage } from '../../features/homepage/homepage';

ReactDOM.hydrateRoot(document.getElementById('app')!, <Homepage />);
